import { useState } from "react";
import { C, uid, Btn, Input, Select, Textarea, Tabs, StatCard, useIsMobile } from "./ui";
import { toast } from "../services/toast";

export function GestionPanel({ maquinariasState, empleadosState, user, profile }) {
  const isMobile = useIsMobile();
  const { maquinarias, createMaquinaria, deleteMaquinaria } = maquinariasState;
  const { empleados, createEmpleado, deleteEmpleado } = empleadosState;
  const [tab, setTab] = useState("empleados");
  const [showEmp, setShowEmp] = useState(false);
  const [empNombre, setEmpNombre] = useState("");
  const [empTel, setEmpTel] = useState("");
  const [empRol, setEmpRol] = useState("");
  const [empObs, setEmpObs] = useState("");
  const [showMaq, setShowMaq] = useState(false);
  const [maqNombre, setMaqNombre] = useState("");
  const [maqTipo, setMaqTipo] = useState("");
  const [maqMarca, setMaqMarca] = useState("");
  const [maqModelo, setMaqModelo] = useState("");
  const [maqAnio, setMaqAnio] = useState("");
  const [maqObs, setMaqObs] = useState("");
  const [confirmar, setConfirmar] = useState(null);

  const agregarEmpleado = async () => {
    if (!empNombre) return;
    try {
      await createEmpleado({
        nombre: empNombre, telefono: empTel, rol: empRol, activo: true, obs: empObs
      });
      setShowEmp(false);
      setEmpNombre("");
      setEmpTel("");
      setEmpRol("");
      setEmpObs("");
      toast.success("Empleado agregado.");
    } catch (e) {
      console.error("Error creando empleado:", e);
      toast.error("No se pudo agregar el empleado: " + (e.message || "error"));
    }
  };

  const eliminarEmpleado = async (id) => {
    try {
      await deleteEmpleado(id);
      setConfirmar(null);
    } catch (e) {
      console.error("Error eliminando empleado:", e);
    }
  };

  const agregarMaquinaria = async () => {
    if (!maqNombre) return;
    try {
      await createMaquinaria({
        nombre: maqNombre, tipo: maqTipo, marca: maqMarca, modelo: maqModelo,
        anio: parseInt(maqAnio) || null, obs: maqObs
      });
      setShowMaq(false);
      setMaqNombre("");
      setMaqTipo("");
      setMaqMarca("");
      setMaqModelo("");
      setMaqAnio("");
      setMaqObs("");
      toast.success("Maquinaria agregada.");
    } catch (e) {
      console.error("Error creando maquinaria:", e);
      toast.error("No se pudo agregar la maquinaria: " + (e.message || "error"));
    }
  };

  const eliminarMaquinaria = async (id) => {
    try {
      await deleteMaquinaria(id);
      setConfirmar(null);
    } catch (e) {
      console.error("Error eliminando maquinaria:", e);
    }
  };

  return (
    <div style={{ flex: 1, overflowY: "auto", background: C.fondo }}>
      <div style={{ padding: isMobile ? "14px 14px" : "20px 24px", maxWidth: 900, margin: "0 auto" }}>
        <div style={{ fontFamily: "serif", fontSize: 22, color: C.tierra, fontWeight: 600, marginBottom: 4 }}>
          ⚙️ Gestión
        </div>
        <div style={{ fontSize: 13, color: C.muted, marginBottom: 18 }}>
          Administrá empleados y maquinaria. Guardados en base de datos.
        </div>

        <Tabs tabs={[
          { id: "empleados", label: "👤 Empleados" },
          { id: "maquinaria", label: "🚜 Maquinaria" }
        ]} active={tab} onChange={setTab} />

        {tab === "empleados" && (
          <>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 14 }}>
              <StatCard val={empleados.length} label="empleados" />
            </div>
            <div style={{ marginBottom: 14 }}>
              <Btn variant="primary" onClick={() => setShowEmp(!showEmp)}>
                {showEmp ? "Cancelar" : "+ Nuevo empleado"}
              </Btn>
            </div>

            {showEmp && (
              <div style={{ background: C.white, borderRadius: 12, padding: 16, marginBottom: 16, border: `1px solid ${C.arenaDark}` }}>
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "0 12px" }}>
                  <Input label="Nombre" value={empNombre} onChange={setEmpNombre} placeholder="Juan" />
                  <Input label="Teléfono" value={empTel} onChange={setEmpTel} placeholder="+598 99 123456" />
                  <Input label="Rol" value={empRol} onChange={setEmpRol} placeholder="Peon, encargado, etc" />
                </div>
                <Textarea label="Observaciones" value={empObs} onChange={setEmpObs} rows={2} />
                <Btn variant="primary" onClick={agregarEmpleado} disabled={!empNombre} style={{ width: "100%" }}>Guardar</Btn>
              </div>
            )}

            {empleados.map((e) => (
              <div key={e.id} style={{ background: C.white, borderRadius: 10, padding: "10px 14px", marginBottom: 7, border: `1px solid ${C.arenaDark}` }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                  <span style={{ fontSize: 18 }}>👤</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: C.tierra }}>{e.nombre}</div>
                    <div style={{ fontSize: 11, color: C.muted }}>
                      {e.rol}{e.telefono ? ` · ${e.telefono}` : ""}
                    </div>
                  </div>
                  {confirmar === e.id ? (
                    <>
                      <button onClick={() => eliminarEmpleado(e.id)} style={{ ...btn, background: C.danger, color: "#fff", borderColor: C.danger }}>Sí</button>
                      <button onClick={() => setConfirmar(null)} style={btn}>No</button>
                    </>
                  ) : (
                    <button onClick={() => setConfirmar(e.id)} style={{ ...btn, color: C.danger }}>✕</button>
                  )}
                </div>
              </div>
            ))}
          </>
        )}

        {tab === "maquinaria" && (
          <>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 14 }}>
              <StatCard val={maquinarias.length} label="máquinas" />
            </div>
            <div style={{ marginBottom: 14 }}>
              <Btn variant="primary" onClick={() => setShowMaq(!showMaq)}>
                {showMaq ? "Cancelar" : "+ Nueva máquina"}
              </Btn>
            </div>

            {showMaq && (
              <div style={{ background: C.white, borderRadius: 12, padding: 16, marginBottom: 16, border: `1px solid ${C.arenaDark}` }}>
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "0 12px" }}>
                  <Input label="Nombre" value={maqNombre} onChange={setMaqNombre} placeholder="Tractor, sembradora, etc" />
                  <Input label="Tipo" value={maqTipo} onChange={setMaqTipo} placeholder="Tractor, cosechadora, etc" />
                  <Input label="Marca" value={maqMarca} onChange={setMaqMarca} placeholder="John Deere" />
                  <Input label="Modelo" value={maqModelo} onChange={setMaqModelo} placeholder="5075E" />
                  <Input label="Año" value={maqAnio} onChange={setMaqAnio} type="number" placeholder="2020" />
                </div>
                <Textarea label="Observaciones" value={maqObs} onChange={setMaqObs} rows={2} />
                <Btn variant="primary" onClick={agregarMaquinaria} disabled={!maqNombre} style={{ width: "100%" }}>Guardar</Btn>
              </div>
            )}

            {maquinarias.map((m) => (
              <div key={m.id} style={{ background: C.white, borderRadius: 10, padding: "10px 14px", marginBottom: 7, border: `1px solid ${C.arenaDark}` }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                  <span style={{ fontSize: 18 }}>🚜</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: C.tierra }}>{m.nombre}</div>
                    <div style={{ fontSize: 11, color: C.muted }}>
                      {m.tipo}{m.marca ? ` · ${m.marca}` : ""}{m.modelo ? ` ${m.modelo}` : ""}{m.anio ? ` · ${m.anio}` : ""}
                    </div>
                  </div>
                  {confirmar === m.id ? (
                    <>
                      <button onClick={() => eliminarMaquinaria(m.id)} style={{ ...btn, background: C.danger, color: "#fff", borderColor: C.danger }}>Sí</button>
                      <button onClick={() => setConfirmar(null)} style={btn}>No</button>
                    </>
                  ) : (
                    <button onClick={() => setConfirmar(m.id)} style={{ ...btn, color: C.danger }}>✕</button>
                  )}
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

const btn = {
  background: C.arena, border: `1px solid ${C.arenaDark}`, borderRadius: 6,
  padding: "6px 9px", fontSize: 12, cursor: "pointer", color: C.tierra, fontFamily: "monospace", flexShrink: 0,
};
